import React from "react";
import { TextField as MUITextField } from "@mui/material"

export type TextFieldProps = {
    label: string,
    value: string, 
    readOnly?: boolean, 
    // required?: boolean,
    onChange?: (s: string) => void, 
    // validate?: (value: string, label: string) => boolean,
    error?: string,
    help?: string,
    [rest: string]: any,
}

export default function TextField({label, value, readOnly, onChange, error, help, ...rest}: TextFieldProps) {
    // const [text, setText] = React.useState(value && "")
    // const [valid, setValid] = React.useState(true)

    // function isValid(v: string): boolean {
    //     if (validate) return validate(v, label)
    //     if (required) return (!v ? "" : v?.trim()).length > 0 // Is there a non white-space value?
    //     return true
    // }

    function handleOnChange(e: React.ChangeEvent<HTMLInputElement>) {
        // if (!valid && required && isValid(e.target.value)) setValid(true)
        // if (validate) {
        //     const valid = validate(e.target.value, label)
        //     setValid(valid)
        // }
        onChange && onChange(e.target.value)
    }

    // function handleOnBlur(e: React.FocusEvent<HTMLInputElement>) {
    //     setValid(isValid(e.target.value))
    // }

    // const variant = readOnly ? "outlined" : "filled"
    const helpText = error ?? help ?? ""

    return <MUITextField label={label} value={value ?? ''} size="small" slotProps={{ input: { readOnly: readOnly } }} {...rest} 
        error={!!error} helperText={helpText}
        onChange={handleOnChange}
        // onBlur={handleOnBlur}
    />
}
